// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KWVy","label":"styles_label__wkaQL"};